var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-tag",class:{
    'top-tag-1': _vm.topValue == 1,
    'top-tag-2': _vm.topValue == 2,
    'top-tag-3': _vm.topValue == 3,
  }},[_vm._v("\n  "+_vm._s(_vm.topValue)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }